import type { RecorderStatusTypes } from "../constants";
import { RECORDER_STATUS } from "../constants";

export const formatTime = (seconds: number) => {
  const mins = Math.floor(seconds / 60);
  const secs = Math.floor(seconds % 60);
  return `${mins.toString().padStart(2, "0")}:${secs.toString().padStart(2, "0")}`;
};

export const generateRandomString = () => {
  const array = new Uint8Array(5);
  crypto.getRandomValues(array);
  return Array.from(array, byte => byte.toString(36))
    .join("")
    .slice(0, 7);
};

export const getStatusProperties = (status: RecorderStatusTypes) => {
  const isRecording = status === RECORDER_STATUS.RECORDING;
  const isBusy =
    status === RECORDER_STATUS.UPLOADING ||
    status === RECORDER_STATUS.PROCESSING;
  const isError =
    status === RECORDER_STATUS.UPLOAD_ERROR ||
    status === RECORDER_STATUS.SERVER_ERROR;

  return { isRecording, isBusy, isError };
};
